import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { RaffleDrawService } from 'app/core/services/raffle-draw.service';
import { ToastService } from 'app/toast/services/toast.service';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import _ from 'lodash'
import { CommonModule } from '@angular/common';
import { TicketsAndGuestsInitialsService } from 'app/manage-tickets-and-guests/services/tickets-and-guests-initials.service';

@Component({
  selector: 'app-view-raffle-winners',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-raffle-winners.component.html',
  styleUrl: './view-raffle-winners.component.scss'
})
export class ViewRaffleWinnersComponent {

  onClose: Function;
  data:any;
  isSimpleRaffle: boolean | null;
  campaign: any;
  

  userDataMap: Map<string, { initials: string; color: string }>;

  constructor(
    private store: Store,
    private raffleHttp:RaffleDrawService,
    private toastService:ToastService,
    public initialsService : TicketsAndGuestsInitialsService
  ) { }

  ngOnInit(): void {
    if(this.isSimpleRaffle){
     this.initialsService.initInitialsMap(this.data)
    }
  }

  getImg(img){
    return img !== '' ? img : '/images/org_logo_default_v2.svg'
  }

  onConfirmSaveWinners(saveWinnersCallback){
    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: "Save winners",
          text: `Are you sure to replace previous winner with new winners?`,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (value) => {
            if(value){
              saveWinnersCallback()
            }
          }
        }
      }});

    this.store.dispatch(action);
  }

  onRemoveWinnerFromSimpleRaffle(item){
    this.raffleHttp.removeWinner(this.campaign.id,item.winnerUserId).subscribe({
      next: () => {
        this.toastService.showSuccess('Winner deleted successfully')
        const index = this.data.findIndex(i => i.winnerUserId === item.winnerUserId);
        if (index !== -1) {
            this.data.splice(index, 1);
            this.campaign.campaignTypeData.raffleWinners.splice(index,1)

        }      
      },
      error: () => {
        // this.toastService.showDanger('Winner deleted successfully')

        // const index = this.data.findIndex(i => i.winnerUserId === item.winnerUserId);
        // if (index !== -1) {
        //     this.data.splice(index, 1);
        // }     
      }
    })
  }

  
}
